// src/components/charts/ActivityChart.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ActivityChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container empty-chart">
        <h3>📈 Actividad diaria</h3>
        <p className="empty-message">No hay datos de actividad en este período</p>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <h3>📈 Actividad diaria</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis 
            dataKey="fecha" 
            stroke="var(--color-texto)"
            tickFormatter={(fecha) => new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })}
          />
          <YAxis stroke="var(--color-texto)" />
          <Tooltip 
            contentStyle={{ 
              background: 'var(--color-fondo)', 
              border: '1px solid var(--color-primario)',
              borderRadius: '10px'
            }} 
          />
          <Legend />
          <Line type="monotone" dataKey="eventos" stroke="var(--color-primario)" strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActivityChart;